<template>
  <div class="text_size">
    <div class="grid_flex mb-4 mt-4" v-if="expire_date != null">
      <div>วันสิ้นสุดโปรโมชั่น {{ $props.expire_date }}</div>
      <div class="promotion_mobile" v-if="promotion_price != null">
        <div class="mr-4">ราคาโปรโมชั่น</div>
        <div>{{ $props.promotion_price }} <span>บาท</span></div>
      </div>
    </div>
    <div class="grid_flex mb-4">
      <div>{{ $props.product_name }}</div>
      <div class="promotion_mobile" v-if="price_unit != null">
        <div class="mr-4 grey--text">ยอดขาย</div>
        <div>{{ $props.price_unit }}</div>
        <div class="ml-4 grey--text">{{ $props.product_unit }}</div>
      </div>
    </div>
    <div class="grid_flex" v-if="expire_product != null">
      <div class="promotion_mobile">
        <div class="mr-3">สินค้าใกล้หมดอายุรอบเดือน :</div>
        <div>{{ $props.expire_product }}</div>
<!--        <div class="ml-3">เดือน</div>-->
      </div>
      <div class="promotion_mobile">
        <div class="mr-3">{{ $props.name }}</div>
        <div>{{ $props.unit }}</div>
        <div class="ml-3">{{ $props.unit_name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "headerexpire_promotion",
  props: [
    'price_unit',
    'product_name',
    'product_unit',
    'expire_date',
    'promotion_price',
    'expire_product',
    'name',
    'unit',
    'unit_name',
  ],
}
</script>

<style scoped>
.text_size {
  font-size: 20px;
}
.grid_flex {
  display: flex;
  justify-content: space-between;
}
.promotion_mobile {
  display: flex;
  justify-content: space-between;
}
@media only screen and (max-width: 600px) {
  .grid_flex {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
    text-align: center;
  }
  .promotion_mobile {
    display: flex;
    justify-content: center;
  }
}
</style>
